import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
	card: {
		width: '100%',
		maxHeight: 300,
		display: 'grid',
		gridTemplateRows: '250px 1fr',
		backgroundColor: '#75319d',
		borderRadius: 40,
		[theme.breakpoints.down('sm')]: {
			maxHeight: 250,
			gridTemplateRows: '5fr 1fr',
			borderRadius: 18,
		},
	},
	imgContainer: {
		height: '100%',
		overflow: 'hidden',
		borderRadius: 40,
		[theme.breakpoints.down('sm')]: {
			borderRadius: 18,
		},
	},
	img: {
		width: '100%',
	},
	nameContainer: {
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	name: {
		fontSize: 25,
		fontWeight: 700,
		[theme.breakpoints.down('sm')]: {
			fontSize: 16,
			fontWeight: 500,
		},
	},
	link: {
		color: 'white',
		textDecoration: 'none',
		width: '25%',
		margin: '3%',
		flexGrow: 1,
		justifyContent: 'space-between',
		[theme.breakpoints.down('sm')]: {
			width: '40%',
		},
	},
}));
